import React from "react";
import { U_USER_ADMIN, G_EXPORT_TRANSACTION, PAY_OVERVIEW_STOP_PAYMENT, U_VIEW_USERS, REGISTER_COMPANIES } from '../../config/PermissionTypes';


export default function RolePermissionsReadOnly(props) {
    const { permissions } = props;

    // List of available Dashboard permissions
    let dashboardPerms = [];

    // List of available Payments tables permissions
    let paymentsPerms = [];
    if (permissions?.includes(G_EXPORT_TRANSACTION)) paymentsPerms.push({ displayName: "Export Data", testId: "payment-permission-export-data" });
    if (permissions?.includes(PAY_OVERVIEW_STOP_PAYMENT)) paymentsPerms.push({ displayName: "Stop Payment", testId: "payment-permission-stop-payment" });

    // List of available User Admin permissions
    let userAdminPerms = [];
    if (permissions?.includes(U_VIEW_USERS)) userAdminPerms.push({ displayName: "View Users", testId: "user-admin-permission-view-users" });
    if (permissions?.includes(U_USER_ADMIN)) userAdminPerms.push({ displayName: "User Management", testId: "user-admin-permission-user-management" });

    let registerCompaniesPerms = [];
    if (permissions?.includes(REGISTER_COMPANIES)) registerCompaniesPerms.push({ displayName: "Register Companies", testId: "register-companies-permission" });

    const hasPermissions = dashboardPerms.length > 0 || paymentsPerms.length > 0 || userAdminPerms.length > 0 || registerCompaniesPerms.length > 0;

    return (
        <>
            <div className="permissions-container" data-testid="user-permission-options">
                <div className='subSectionTitle'> Permissions</div>
                {hasPermissions ?
                    <div>
                        <div className="row">
                            {dashboardPerms.length > 0 &&
                                <div className="col">
                                    <p className="permission-title">Dashboard</p>
                                    <div className="efup-permissions-list-item">
                                        <ul>
                                            {dashboardPerms.map((perm, i) => {
                                                return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                    {perm.displayName}
                                                </label></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row">
                            {paymentsPerms.length > 0 &&
                                <div className="col">
                                    <p className="permission-title">Payment Pages</p>
                                    <div className="efup-permissions-list-item">
                                        <ul>
                                            {paymentsPerms.map((perm, i) => {
                                                return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                    {perm.displayName}
                                                </label></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row">
                            {userAdminPerms.length > 0 &&
                                <div className="col">
                                    <p className="permission-title">User Admin</p>
                                    <div className="efup-permissions-list-item">
                                        <ul>
                                            {userAdminPerms.map((perm, i) => {
                                                return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                    {perm.displayName}
                                                </label></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row">
                            {registerCompaniesPerms.length > 0 &&
                                <div className="col">
                                    <p className="permission-title">Register Companies</p>
                                    <div className="efup-permissions-list-item">
                                        <ul>
                                            {registerCompaniesPerms.map((perm, i) => {
                                                return <li key={i} data-testid={perm.testId}><label className="efup-permissions-list-item-label">
                                                    {perm.displayName}
                                                </label></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                    </div> :
                    <div>No permissions assigned to this role.</div>
                }
            </div> </>
    );
}